// this is the function for toggling number of product in a row
function toggleProductGrid(lines) {
    const productGrid = document.getElementById('main-collection-product-grid');
    
    productGrid.classList.remove('collection__page-products-3');
    productGrid.classList.remove('collection__page-products');
    productGrid.classList.remove('collection__page-products-2');
    
     if (lines === 2) {
        productGrid.classList.add('collection__page-products-2');
    } else if (lines === 3) {
        productGrid.classList.add('collection__page-products-3');
    }else if (lines === 4) {
        productGrid.classList.add('collection__page-products');
    }
    const gridButtons = document.querySelectorAll('.st-grid-changer button');
const currentColumns = parseInt(lines); // Assuming 'lines' is the variable containing the current column value

gridButtons.forEach(button => {
    const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
    const isActive = button.classList.contains('active');

    if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active'); // Add 'active' class
    } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active'); // Remove 'active' class
    }
});

}
// infinte loader js
document.addEventListener('DOMContentLoaded', function () {
    const target = document.querySelector('#product-grid-Pagination');
  if (target) {
    window.observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (document.querySelector('#product-grid-Pagination .btnLoder'))
            document.querySelector('#product-grid-Pagination .btnLoder').click();
        }
      });
    });

    window.observer1.observe(target);
    window.onClickCollectionPagination = async (link, event) => {
      event.preventDefault();

      link.style.width = `${link.offsetWidth}px`;
      link.style.height = `${link.offsetHeight}px`;
      link.innerHTML = `
         
      <div class="st-results-loader">
      <div class="result-loading" style="text-align: center">
     <div class="st-spinner">
    <div class="lds-facebook">
    <div></div>
    <div></div>
    <div></div>
  </div>
    </div>
      </div>
      </div>

    `;

      const respoonse = await fetch(link.getAttribute('href'));
      const data = await respoonse.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(data, 'text/html');

      document
        .querySelector('.collection__page .collection__page-products')
        .insertAdjacentHTML('beforeend', newDocument.querySelector('.collection__page .collection__page-products').innerHTML);

      document
        .querySelector('#product-grid-Pagination')
        .replaceWith(newDocument.querySelector('#product-grid-Pagination'));

      window.observer1.observe(document.querySelector('#product-grid-Pagination'));
    };
  }
  });
